import { useState } from "react";
import { TbLogin2 } from "react-icons/tb";
import { IoMdReturnLeft } from "react-icons/io";
import { LoginSecondStep } from "../../../Services/Api/AuthRequests";
import { useNavigate } from "react-router-dom";

const LoginFieldSecond = ({backToFirstStep, onLogged, codeId, onFail}) => {
    const [code, setCode] = useState("");

    const Login = () => {
      if(code)
        LoginSecondStep(code, codeId, onLogged, onFail)
    }

    return (
        <>
          <div className="usernameField loginField">
            <span className="pl-1">Kod Weryfikacji</span>
            <input className="input" onChange={(e) => setCode(e.target.value)} type="text"></input>
          </div>    
          <span className="text-glyellow text-center px-6 font-bold my-2">Twój kod został wysłany na maila!</span>
          <span className="text-glyellow text-center px-6 font-bold my-2">Kod jest ważny tylko kilka minut!</span>
          <div className="flex" style={{gap: "2%"}}>
            <button onClick={() => backToFirstStep()} className="loginBtn h-10 bg-glwhite-500" style={{ width: "48%"}}><IoMdReturnLeft  className="btnIcon"/>Powrót</button>     
            <button onClick={() => Login()} className="loginBtn h-10" style={{ width: "48%"}}><TbLogin2 className="btnIcon"/>Zaloguj</button>         
          </div> 
        </>
    )
}

export default LoginFieldSecond;